import { SVGProps } from 'react';

interface LogoProps {
    className?: string;
    iconClassName?: string;
    textClassName?: string;
    hideText?: boolean;
}

export default function Logo({
    className = "flex items-center gap-2",
    iconClassName = "w-6 h-6",
    textClassName = "text-xl font-bold text-[#0F172A]",
    hideText = false
}: LogoProps) {
    return (
        <div className={className}>
            <img src="/images/logo.webp" alt="Reputrust Logo" className="h-[72px] w-auto object-contain drop-shadow-sm" />
        </div>
    );
}
